var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        },
        [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mb-2" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("receiving_emails"),
                      "label-for": "emailsInput"
                    }
                  },
                  [
                    _c("validation-provider", {
                      attrs: { name: "emailsInput" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("emails-input", {
                                ref: "emailsInput",
                                attrs: {
                                  emailsInput: _vm.emailsInitialTag,
                                  sendButton: false
                                },
                                on: { emailsChanged: _vm.emailsChanged }
                              }),
                              _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "flex justify-end mb-4" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(255, 255, 255, 0.15)",
                      expression: "'rgba(255, 255, 255, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "float-right mr-1",
                  attrs: { variant: "primary", type: "submit" }
                },
                [_vm._v(" Salvar ")]
              ),
              !_vm.hideBackButton
                ? _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.goBack }
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CornerUpLeftIcon" }
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back")))
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "b-card-code",
        {
          key: _vm.legalEntityId + "-incident-form",
          attrs: {
            title: "URL Formulário de Incidente",
            codeVisible: "true",
            showCopy: "true",
            codeEmbed: "true",
            shortUrl: _vm.shortUrl
          },
          scopedSlots: _vm._u([
            {
              key: "code",
              fn: function() {
                return [_vm._v(" " + _vm._s(_vm.formUrl) + " ")]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-card-text", [
            _vm._v(
              " Use esta URL para que a instituição/empresa possa abrir o formulário de incidentes referentes aos dados. "
            )
          ])
        ],
        1
      ),
      _c(
        "b-card-code",
        {
          key: _vm.legalEntityId + "-incident-protocol",
          attrs: {
            title: "Protocolo - Página de Consulta Pública",
            codeVisible: "true",
            showCopy: "true",
            codeEmbed: "true"
          },
          scopedSlots: _vm._u([
            {
              key: "code",
              fn: function() {
                return [_vm._v(" " + _vm._s(_vm.protocolQueryUrl) + " ")]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-card-text", [
            _vm._v(
              " Use esta URL para realizar consulta da situação e tratamento do formulário de incidentes referentes aos dados. "
            )
          ])
        ],
        1
      ),
      !_vm.hideBackButton
        ? _c(
            "div",
            { staticClass: "flex justify-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }